module.exports = __webpack_public_path__ + "img/1.7bf14e1a.jpg";